<template>
  <BasePagesWrapper :page-list="list" />
</template>

<script>
import BasePagesWrapper from "components/base/BasePagesWrapper";
export default {
  name: "clients",
  components: {BasePagesWrapper},
  computed: {
    list() {
      return [
        {
          toName: 'clientsCompany',
          text: this.localStorage.translations.pages.pages.buttons.company,
          if: true,
        },
        {
          toName: 'clientsCompanySales',
          text: this.localStorage.translations.pages.pages.buttons['company-sales'],
          if: true,
        },
      ]
    },
  },
}
</script>